import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { URLS } from '../../../data/navigation/navigation.data';
import { CookieConsentService } from '../../../service/cookie-consent/cookie-consent.service';
import { AnalyticsService } from '../../../service/analytics/analytics.service';

@Component( {
  selector: 'app-cookies',
  templateUrl: './cookie-popup.component.html',
  styleUrls: [ './cookie-popup.component.scss' ]
} )
export class CookiePopupComponent implements OnInit, AfterViewInit {

  accepted = false;

  // True when our own popup content was stripped from the page (e.g. by a cookie
  // / annoyance filter in an ad blocker like Adblock Plus). We then collapse the
  // whole bar so the user never sees an empty, undismissable shell. We do NOT try
  // to restore the content — no arms race with the blocker, just graceful failure.
  stripped = false;

  public URLS = URLS;

  constructor(
    private consent: CookieConsentService,
    private analyticsService: AnalyticsService,
    private host: ElementRef<HTMLElement>,
  ) {
  }

  ngOnInit(): void {
    // Reactive state (shared with the theme-offer toast so it can stack above
    // this bar and drop once accepted).
    this.consent.accepted.subscribe( accepted => this.accepted = accepted );
  }

  ngAfterViewInit(): void {
    // Give a content blocker a moment to act, then verify our dismiss button is
    // still rendered. Two checks: an early one to minimise any empty-shell flash,
    // and a later one in case the blocker acts late. Once collapsed, it stays.
    setTimeout( () => this.checkStripped(), 150 );
    setTimeout( () => this.checkStripped(), 700 );
  }

  // The dismiss button is our proxy for "did our content survive?": if it is gone
  // or rendered at zero size (removed or display:none-d by a blocker), the bar is
  // an empty shell, so we hide the whole thing.
  private checkStripped(): void {
    if ( this.accepted || this.stripped ) { return; }
    const btn = this.host.nativeElement.querySelector( '.cookie-accept' ) as HTMLElement | null;
    const rect = btn ? btn.getBoundingClientRect() : null;
    if ( !rect || rect.width <= 0 || rect.height <= 0 ) {
      this.stripped = true;
    }
  }

  setAccepted() {
    this.analyticsService.logEvent( 'Cookie Consent Accepted', {} );
    this.consent.accept();
  }
}
